/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Key_CopiedInputs */

const en_settings_apikeys_key_copied = /** @type {(inputs: Settings_Apikeys_Key_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key copied to clipboard`)
};

const zh_settings_apikeys_key_copied = /** @type {(inputs: Settings_Apikeys_Key_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密钥已复制到剪贴板`)
};

/**
* | output |
* | --- |
* | "Key copied to clipboard" |
*
* @param {Settings_Apikeys_Key_CopiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_key_copied = /** @type {((inputs?: Settings_Apikeys_Key_CopiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Key_CopiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_key_copied(inputs)
	return zh_settings_apikeys_key_copied(inputs)
});
export { settings_apikeys_key_copied as "settings.apikeys.key_copied" }